import React from 'react';
import { SimpleSliderBase } from "@reusejs/react";

export interface TrendingPropertiesSliderComponentProps {
  elements: React.ReactNode[];
}

export default function TrendingPropertiesSliderComponent(
  props: TrendingPropertiesSliderComponentProps
) {
  const leftArrow = (props: any) => {
    return (
      <div
        className="absolute top-0 sm:-top-14 sm:right-10 flex cursor-pointer items-center justify-center rounded-l bg-white px-3 py-1 border border-gray-200"
        onClick={props.slideLeft}
      >
        {"<"}
      </div>
    );
  };

  const rightArrow = (props: any) => {
    return (
      <div
        className="absolute top-0 left-9 sm:left-[unset] sm:-top-14 sm:right-1 flex cursor-pointer items-center justify-center rounded-r bg-white px-3 py-1 border border-gray-200"
        onClick={props.slideRight}
      >
        {">"}
      </div>
    );
  };

  return (
    <SimpleSliderBase
      id={"TrendingPropertiesSlider"}
      scrollWidth={809}
      renderArrowLeft={leftArrow}
      renderArrowRight={rightArrow}
      simpleSliderBaseClasses={{
        layout: "relative pt-10 gap-x-10",
      }}
    >
      {props.elements}
    </SimpleSliderBase>
  );
}